<template>
<div id="apptable" v-cloak>

    <b-card header="Questionari compilati" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-4">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                    <template slot="titolo" scope="row">{{row.value}}</template>
                    <template slot="titoloevento" scope="row">{{row.value}}</template>
                    <template slot="cognomesocio" scope="row">{{row.value}}</template>
                    <template slot="tipoVis" scope="row">{{row.value}}</template>
                    <template slot="attivoVis" scope="row">{{row.value}}</template>

                    <template slot="modifica" scope="row">
                        <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->                        
                        <b-btn style="margin:0px 0px 1px 2px;" size="sm" variant="info" @click.stop="risposte(row.item,row.index,$event.target)">Risposte</b-btn>
                    </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>
    
</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    TipoQuestionario
} from '../classes.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                titolo: {
                    label: 'Titolo',
                    sortable: true
                },
                titoloevento: {
                    label: 'Evento',
                    sortable: true
                },    
                cognomesocio: {
                    label: 'Cognome Socio',
                    sortable: true
                },    
                tipoVis: {
                    label: 'Tipo',
                    sortable: true
                },              
                attivoVis: {
                    label: 'Attivo',
                    sortable: true
                },               
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            id_scheda: this.$route.params.id_scheda || null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,            
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {        
        getTipo(tipo) {
            var tq = new TipoQuestionario();
            return tq.getTipoByFlag(tipo);
        },
        risposte(item, index, button) {
            let titoloAux = encodeURIComponent(item.titolo)
            this.$router.push({
                path: `/app/dettagliorisposta/id/${item.id}/titolo/${titoloAux}`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    },
    created: function () {   
        
        if(!ctrlVismenu("E")){
            this.$router.replace('/accessdenied');
            return;
        }     

        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/questionaririsposte/id_scheda/' + this.id_scheda, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        apptable.items.forEach(function(element, index) {
                            element.attivoVis = (element.flagsta == 'S' ? 'Sì' : 'No');                                                  
                            element.tipoVis = apptable.getTipo(element.tipo);
                            delete element.uteins; //per motivi di ricerca
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
